var chunkMapping = {
	"100": [
		1100
	],
	"252": [
		1252
	],
	"276": [
		3276
	],
	"284": [
		5284
	],
	"292": [
		9292
	],
	"330": [
		4330
	],
	"356": [
		1356
	],
	"412": [
		6412
	],
	"548": [
		9548
	],
	"550": [
		3550
	],
	"562": [
		181
	],
	"614": [
		1614
	],
	"698": [
		9698
	],
	"740": [
		740
	],
	"762": [
		6762
	],
	"815": [
		6815
	],
	"818": [
		8818
	],
	"880": [
		9880
	]
};
var idToExternalAndNameMapping = {
	"181": [
		"default",
		"./VariableRate",
		5167
	],
	"740": [
		"default",
		"./FixitTool",
		2647
	],
	"1100": [
		"default",
		"./InSeasonWeb",
		4363
	],
	"1252": [
		"default",
		"./Settings",
		5628
	],
	"1356": [
		"default",
		"./ModuleFederationExample",
		8182
	],
	"1614": [
		"default",
		"./TccReportsPlugin",
		7023
	],
	"3276": [
		"default",
		"./DmbWeb",
		1926
	],
	"3550": [
		"default",
		"./DataInboxWeb",
		8143
	],
	"4330": [
		"default",
		"./ProgramsPlugin",
		183
	],
	"5284": [
		"default",
		"./AppsMarketplacePlugin",
		6727
	],
	"6412": [
		"default",
		"./DataHub",
		4216
	],
	"6762": [
		"default",
		"./TccScriptCreatorPlugin",
		5065
	],
	"6815": [
		"default",
		"./FieldSelectionPlugin",
		8907
	],
	"8818": [
		"default",
		"./OperationHub",
		7809
	],
	"9292": [
		"default",
		"./CropPlanning",
		2454
	],
	"9548": [
		"default",
		"./InformationArchitecture",
		9202
	],
	"9698": [
		"default",
		"./SeasonReportsWeb",
		8995
	],
	"9880": [
		"default",
		"./Dashboard",
		8807
	]
};
var idToRemoteMap = {
	"181": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"740": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1100": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1252": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1356": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1614": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"3276": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"3550": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"4330": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"5284": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6412": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6762": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6815": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"8818": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9292": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9548": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9698": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9880": [
		{
			"externalType": "promise",
			"name": ""
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"181": {
		"shareScope": "default",
		"name": "./VariableRate",
		"externalModuleId": 5167,
		"remoteName": ""
	},
	"740": {
		"shareScope": "default",
		"name": "./FixitTool",
		"externalModuleId": 2647,
		"remoteName": ""
	},
	"1100": {
		"shareScope": "default",
		"name": "./InSeasonWeb",
		"externalModuleId": 4363,
		"remoteName": ""
	},
	"1252": {
		"shareScope": "default",
		"name": "./Settings",
		"externalModuleId": 5628,
		"remoteName": ""
	},
	"1356": {
		"shareScope": "default",
		"name": "./ModuleFederationExample",
		"externalModuleId": 8182,
		"remoteName": ""
	},
	"1614": {
		"shareScope": "default",
		"name": "./TccReportsPlugin",
		"externalModuleId": 7023,
		"remoteName": ""
	},
	"3276": {
		"shareScope": "default",
		"name": "./DmbWeb",
		"externalModuleId": 1926,
		"remoteName": ""
	},
	"3550": {
		"shareScope": "default",
		"name": "./DataInboxWeb",
		"externalModuleId": 8143,
		"remoteName": ""
	},
	"4330": {
		"shareScope": "default",
		"name": "./ProgramsPlugin",
		"externalModuleId": 183,
		"remoteName": ""
	},
	"5284": {
		"shareScope": "default",
		"name": "./AppsMarketplacePlugin",
		"externalModuleId": 6727,
		"remoteName": ""
	},
	"6412": {
		"shareScope": "default",
		"name": "./DataHub",
		"externalModuleId": 4216,
		"remoteName": ""
	},
	"6762": {
		"shareScope": "default",
		"name": "./TccScriptCreatorPlugin",
		"externalModuleId": 5065,
		"remoteName": ""
	},
	"6815": {
		"shareScope": "default",
		"name": "./FieldSelectionPlugin",
		"externalModuleId": 8907,
		"remoteName": ""
	},
	"8818": {
		"shareScope": "default",
		"name": "./OperationHub",
		"externalModuleId": 7809,
		"remoteName": ""
	},
	"9292": {
		"shareScope": "default",
		"name": "./CropPlanning",
		"externalModuleId": 2454,
		"remoteName": ""
	},
	"9548": {
		"shareScope": "default",
		"name": "./InformationArchitecture",
		"externalModuleId": 9202,
		"remoteName": ""
	},
	"9698": {
		"shareScope": "default",
		"name": "./SeasonReportsWeb",
		"externalModuleId": 8995,
		"remoteName": ""
	},
	"9880": {
		"shareScope": "default",
		"name": "./Dashboard",
		"externalModuleId": 8807,
		"remoteName": ""
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}